module.exports = __webpack_public_path__ + "static/media/resume.4832f9b7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/misc/resume.pdf
// module id = 451
// module chunks = 1